
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import loader from "../../assets/Images/loader.gif"
import refreshIcon from "../../assets/Images/refresh.png"
import exportExcel from "../../assets/Images/export-excel.png"
import * as api from '../../api_function';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ApiExecutor from "./ApiExecutor";
import { toast } from "react-toastify";


const AdminAccess = () => {
    const userName = sessionStorage.getItem('userName');
    const userEmail = sessionStorage.getItem('userEmail');
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    // const [activeForm, setActiveForm] = useState("ControllerList");
    // const [users, setUsers] = useState([]);
    const [formData, setFormData] = useState([]);
    const [userData, setUserData] = useState("");
    const [getAllUsersData, setAllUsersData] = useState([]);
    const [getAdminUser, setAdminUser] = useState([]);
    const [getSearchInput, setSearchInput] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [getClickedTab, setClickedTab] = useState(null);
    const [getFilteredData, setFilteredData] = useState(null);
    const [isOcrClicked, setIsOcrClicked] = useState(false);
    const [isInstallationDataClicked, setIsInstallationDataClicked] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(5);
    const [getData, setGetData] = useState(null);
    const [expandedRows, setExpandedRows] = useState({});


    const redirectBackPage = () => {
        Swal.fire({
            html: '<div style="font-size: 15px;">Do you want to go back to the previous screen?</div>',
            showCancelButton: true,
            confirmButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">YES</span>',
            cancelButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            customClass: {
                popup: "custom-popup",
                confirmButton: "custom-confirm-button",
                cancelButton: "custom-cancel-button",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                navigate("/dashboard");
            }
        });
    };

    const style = {
        control: (base) => ({
            ...base,
            border: 0,
            // Remove box shadow
            boxShadow: "none",
            backgroundColor: "transparent",
            color: "black",
        }),
        inputFocused: {
            boxShadow: "none",
            fontSize: "14px",
        },
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const getAllUsers = await api.getAllUsers();
                // console.log("getAllUsers", getAllUsers.data);

                if (getAllUsers?.meta?.Status) {
                    const adminUsers = getAllUsers.data.filter((data) => (data.role)?.toLowerCase() === 'admin' && data.email === userEmail)
                    // console.log(adminUsers);
                    setAdminUser(adminUsers?.length > 0)

                    const sortedData = getAllUsers.data.sort((a, b) => {
                        const dateA = new Date(a.updated_at || a.created_at);
                        const dateB = new Date(b.updated_at || b.created_at);
                        return dateB - dateA; // descending order (latest first)
                    });

                    setAllUsersData(sortedData)  // static API response
                    setUserData(sortedData);
                    setFilteredData(sortedData)

                }
            } catch (error) {
                console.error("Error:", error);
            } finally {
                setLoading(false)
            }
        }
        fetchData();
    }, [isSubmitted])

    useEffect(() => {
        const fetchInstallationData = async () => {
                try {
                    setLoading(true)
                    const apiUrl = "https://oneml.spectra.co/api/installation/getdata"

                    const otpResponse = await fetch(apiUrl, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                        },
                    });
                    const responseData = await otpResponse.json();


                    if (responseData.status === "success" && responseData.data && responseData.data.data) {
                        setGetData(responseData.data.data);
                        console.log("getData", responseData.data.data);

                    } else {
                        toast.error("something went wrong", {
                            position: toast.POSITION.BOTTOM_CENTER,
                            autoClose: 2000,
                        });
                    }

                } catch (error) {
                    console.error("Error sending OTP:", error);

                } finally {
                    setLoading(false);
                }
        }
        fetchInstallationData();
    }, []);



    const selectedUser = (user) => {
        // console.log("updateUser:", user);
        setFormData(user)
    };

    const refreshClick = (user) => {
        setFormData({
            full_name: "",
            username: "",
            email: "",
            pg: "0",
            profi: "0",
            mra: "0",
            hotel: "0",
            status: "1",
        })
    };


    const handleChange = (e) => {
        const { name, type, checked, value } = e.target;
        const newValue = type === "checkbox" ? (checked ? "1" : "0") : value;
        setFormData({ ...formData, [name]: newValue });
        // searchUserData(e)
    };

    useEffect(() => {
        if (getData) {
            setCurrentPage(1);
            setExpandedRows({}); // Reset expanded rows when new data is loaded
        }
    }, [getData]);

    // Reset expanded rows when page changes
    useEffect(() => {
        setExpandedRows({}); // Collapse all rows when changing pages
    }, [currentPage]);

    // Toggle row expansion
    const toggleRowExpansion = (index) => {
        setExpandedRows(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData?.email) {
            alert("Please Enter E-mail.")
            return;
        }
        // console.log("Form Submitted:", formData);
        try {
            setLoading(true);
            const addUpdateResult = await api.addUpdateUserRole(formData);
            // console.log(addUpdateResult?.meta?.Message);
            if (addUpdateResult?.meta?.Status) {
                Swal.fire({
                    title: '<div style="font-size: 18px;">Success</div>',
                    text: addUpdateResult?.meta?.Message,
                    icon: 'success',
                    customClass: {
                        popup: 'swal2-smaller-popup'
                    },
                    didOpen: () => {
                        const popup = document.querySelector('.swal2-smaller-popup');
                        if (popup) {
                            popup.style.width = '300px'; // adjust as needed
                            popup.style.padding = '1rem';
                            popup.style.fontSize = '14px';
                        }
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        refreshClick();
                        setIsSubmitted(prev => !prev);

                        // Remove 'active' from all tabs
                        document.querySelectorAll('.nav-link').forEach((el) => {
                            el.classList.remove('active');
                        });

                        // Add 'active' to the specified tab
                        const tabToActivate = document.getElementById("navlink-all");
                        if (tabToActivate) {
                            tabToActivate.classList.add('active');
                        }
                    }
                });
            } else {
                Swal.fire({
                    title: '<div style="font-size: 22px; margin-top:5px;">Error</div>',
                    text: addUpdateResult?.meta?.Message || "Somthing went wrong!",
                    icon: "error"
                })
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }

    };

    const searchUserData = async (e) => {
        e.preventDefault();
        setSearchInput(e.target.value)
        const searchKeyword = e.target.value
        // console.log("Form Submitted:", userData, searchKeyword);

        if (searchKeyword.length < 3) {
            if (searchKeyword.length === 0) {
                // setUserData(getAllUsersData); getClickedTab
                if (getClickedTab === "active") {
                    const activeUser = getAllUsersData.filter((data) => data.status == "1")
                    setUserData(activeUser)

                } else if (getClickedTab === "inactive") {
                    const inactiveUser = getAllUsersData.filter((data) => data.status == "0")
                    setUserData(inactiveUser)

                } else {
                    setUserData(getAllUsersData)
                }
            }
            // return;
        }

        const searchedRow = getFilteredData?.filter(user =>
            (user.full_name?.toLowerCase()?.includes(searchKeyword.toLowerCase())) ||
            (user.username?.toLowerCase()?.includes(searchKeyword.toLowerCase())) ||
            (user.email?.toLowerCase()?.includes(searchKeyword.toLowerCase()))
        );

        // console.log(searchedRow);
        setUserData(searchedRow)

    };


    const filterUser = async (e) => {
        e.preventDefault();
        setIsOcrClicked(false)
        setIsInstallationDataClicked(false)
        const tabName = e.currentTarget.getAttribute("href");
        setClickedTab(tabName)

        // console.log(tabName);
        if (tabName === "all") {
            setUserData(getAllUsersData)
            setFilteredData(getAllUsersData)
        } else if (tabName === "active") {
            const activeUser = getAllUsersData.filter((data) => data.status == "1")
            setUserData(activeUser)
            setFilteredData(activeUser)

        } else if (tabName === "inactive") {
            const inactiveUser = getAllUsersData.filter((data) => data.status == "0")
            setUserData(inactiveUser)
            setFilteredData(inactiveUser)
        } else if (tabName === "ocr") {
            setIsOcrClicked(true)
        } else if (tabName === "inst") {
            setIsInstallationDataClicked(true)

        }
    }

    const sortByChange = async (e) => {
        e.preventDefault();
        const value = e.target.value
        // console.log("value: ", value, getAllUsersData);
        let sortedData;

        if (value === "NameAZ") {
            sortedData = [...getFilteredData].sort((a, b) => {
                const nameA = a.full_name?.toLowerCase() || "";
                const nameB = b.full_name?.toLowerCase() || "";
                return nameA.localeCompare(nameB); // ascending alphabetical order
            });

        } else if (value === "NameZA") {
            sortedData = [...getFilteredData].sort((a, b) => {
                const nameA = a.full_name?.toLowerCase() || "";
                const nameB = b.full_name?.toLowerCase() || "";
                return nameB.localeCompare(nameA); // ascending alphabetical order
            });

        } else if (value === "CreatedLast") {
            sortedData = [...getFilteredData].sort((a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);
                return dateB - dateA; // descending order (latest first)
            });

        } else if (value === "CreatedFirst") {
            sortedData = [...getFilteredData].sort((a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);
                return dateA - dateB; // descending order (latest first)
            });

        }
        else if (value === "UpdatedLast") {
            sortedData = [...getFilteredData].sort((a, b) => {
                const dateA = new Date(a.updated_at);
                const dateB = new Date(b.updated_at);
                return dateB - dateA; // descending order (latest first)
            });

        } else if (value === "UpdatedFirst") {
            sortedData = [...getFilteredData].sort((a, b) => {
                const dateA = new Date(a.updated_at);
                const dateB = new Date(b.updated_at);
                return dateA - dateB; // descending order (latest first)
            });
        } else if (value === "pg") {
            sortedData = getFilteredData.filter((data) => data.pg == "1")
        } else if (value === "hotel") {
            sortedData = getFilteredData.filter((data) => data.hotel == "1")
        } else if (value === "office") {
            sortedData = getFilteredData.filter((data) => data.profi == "1")
        } else if (value === "mra") {
            sortedData = getFilteredData.filter((data) => data.mra == "1")
        } else {
            sortedData = [...getFilteredData].sort((a, b) => {
                const dateA = new Date(a.updated_at || a.created_at);
                const dateB = new Date(b.updated_at || b.created_at);
                return dateB - dateA; // descending order (latest first)
            });
        }

        setUserData(sortedData)

    }


    const exportToExcel = (usersData, filename = "field_force_users_role.xlsx") => {
        // Convert JSON to worksheet
        const data = usersData.map(({ id, role, ...rest }) => rest);
        // console.log(data);

        const worksheet = XLSX.utils.json_to_sheet(data);

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

        // Write workbook to binary array
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        });

        // Save to file
        const dataBlob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        saveAs(dataBlob, filename);
    };

    // if (userName?.toLowerCase() === "manager1") {
    if (getAdminUser) {
        return (
            <>
                {/* ***********Header********* */}
                <div className="container-fluid text-light Header-style header">
                    <div className="p-3">
                        <span
                            className=""
                            style={{ cursor: "pointer" }}
                            onClick={redirectBackPage}
                        >
                            <i className="fa-solid fa-arrow-left-long"></i>
                        </span>
                        <span className="p-1 m-2">Accounts and Privileges</span>
                    </div>

                    {/* Navigation tabs: ALL , OPEN , CLOSED */}
                    <div className=" container-fluid">
                        <ul className="nav nav-tabs">
                            <li className="nav-item">
                                <a onClick={(e) => filterUser(e)} id="navlink-all" className="nav-link active" data-bs-toggle="tab" href="all">All</a>
                            </li>
                            <li className="nav-item">
                                <a onClick={(e) => filterUser(e)} className="nav-link" data-bs-toggle="tab" href="active">Active</a>
                            </li>
                            <li className="nav-item">
                                <a onClick={(e) => filterUser(e)} className="nav-link" data-bs-toggle="tab" href="inactive">Inactive</a>
                            </li>
                            <li className="nav-item">
                                <a onClick={(e) => filterUser(e)} className="nav-link" data-bs-toggle="tab" href="ocr">OCR</a>
                            </li>
                            <li className="nav-item">
                                <a onClick={(e) => filterUser(e)} className="nav-link" data-bs-toggle="tab" href="inst">Installation</a>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* ************Header end************ */}


                {isOcrClicked &&
                    <div className="tab-content tab-main" style={{ marginTop: '100px' }} >
                        <div className="tab-pane fade show active" id="all">
                            <ApiExecutor />
                        </div>
                    </div>
                }


                {isInstallationDataClicked &&
                    <div className="tab-content tab-main" style={{ marginTop: '100px' }} >
                        <div className="tab-pane fade show active" id="all">
                            {/* <InstallationData /> */}
                            {getData && (
                                <div className="table-container">
                                    {/* <div className="scroll-indicator">Scroll for more columns</div> */}
                                    <div className="table-wrapper">
                                        <table className="data-table">
                                            <thead>
                                                <tr>
                                                    <th>Action</th>
                                                    <th>S.No</th>
                                                    <th>CAN ID</th>
                                                    <th>Product Segment</th>
                                                    <th>Source</th>
                                                    <th>Quality Score</th>
                                                    <th>Quality Band</th>
                                                    <th>Image</th>
                                                    <th>Description</th>
                                                    <th>Best Practices</th>
                                                    <th>Date & Time</th>
                                                    <th>Latitude</th>
                                                    <th>Longitude</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getData && getData.length > 0 ? (
                                                    (() => {
                                                        // Calculate pagination
                                                        const indexOfLastItem = currentPage * itemsPerPage;
                                                        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
                                                        const currentItems = getData.slice(indexOfFirstItem, indexOfLastItem);

                                                        return currentItems.flatMap((item, index) => {
                                                            const globalIndex = indexOfFirstItem + index;
                                                            const isExpanded = expandedRows[globalIndex];
                                                            const hasRubric = item.rubric && Object.keys(item.rubric).filter(key => key !== 'totals').length > 0;

                                                            const mainRow = (
                                                                <tr key={`main-${index}`}>
                                                                    <td>
                                                                        {hasRubric && (
                                                                            <button
                                                                                onClick={() => toggleRowExpansion(globalIndex)}
                                                                                style={{
                                                                                    background: 'none',
                                                                                    border: 'none',
                                                                                    cursor: 'pointer',
                                                                                    fontSize: '18px',
                                                                                    color: '#4a90e2',
                                                                                    padding: '5px 10px'
                                                                                }}
                                                                                title={isExpanded ? "Hide Details" : "Show Details"}
                                                                            >
                                                                                {isExpanded ? '▼' : '▶'}
                                                                            </button>
                                                                        )}
                                                                    </td>
                                                                    <td>{globalIndex + 1}</td>
                                                                    <td>{item.canId || '-'}</td>
                                                                    <td>{item.Product_Segment || '-'}</td>
                                                                    <td>{item.Source || '-'}</td>
                                                                    
                                                                    {/* <td>{item.srNumber || '-'}</td> */}
                                                                    <td><strong>{item.score_out_of_10 !== undefined && item.score_out_of_10 !== null ? item.score_out_of_10 : '-'}</strong>{item.score_out_of_10 !== undefined && item.score_out_of_10 !== null ? '/10' : ''}</td>
                                                                    <td>
                                                                        {item.quality_band ? (
                                                                            <span style={{
                                                                                padding: '4px 8px',
                                                                                borderRadius: '4px',
                                                                                backgroundColor: item.quality_band === 'Excellent' ? '#d4edda' :
                                                                                    item.quality_band === 'Good' ? '#d1ecf1' :
                                                                                        item.quality_band === 'Fair' ? '#fff3cd' : '#f8d7da',
                                                                                color: item.quality_band === 'Excellent' ? '#155724' :
                                                                                    item.quality_band === 'Good' ? '#0c5460' :
                                                                                        item.quality_band === 'Fair' ? '#856404' : '#721c24'
                                                                            }}>
                                                                                {item.quality_band}
                                                                            </span>
                                                                        ) : '-'}
                                                                    </td> 
                                                                    <td>
                                                                        {item.image ? (
                                                                            <a href={item.image} target="_blank" rel="noopener noreferrer" style={{ color: '#4a90e2', textDecoration: 'underline' }}>View Image</a>
                                                                        ) : '-'}
                                                                    </td>
                                                                    <td style={{ maxWidth: '250px', whiteSpace: 'normal' }}>{item.narrative || '-'}</td>
                                                                    <td style={{ maxWidth: '200px', whiteSpace: 'normal' }}>
                                                                        {item.best_practices && Array.isArray(item.best_practices) ? (
                                                                            <ul style={{ margin: 0, paddingLeft: '20px', textAlign: 'left' }}>
                                                                                {item.best_practices.map((practice, idx) => (
                                                                                    <li key={idx}>{practice}</li>
                                                                                ))}
                                                                            </ul>
                                                                        ) : item.best_practices || '-'}
                                                                    </td>



                                                                    <td>{item.dateTime || '-'}</td>
                                                                    <td>{item.Latitude || '-'}</td>
                                                                    <td>{item.Longitude || '-'}</td>
                                                                </tr>
                                                            );

                                                            // Expanded row with criteria details
                                                            const expandedRow = isExpanded && hasRubric ? (
                                                                <tr key={`expanded-${index}`}>
                                                                    <td colSpan="12" style={{ padding: '20px', backgroundColor: '#d9d7d7' }}>
                                                                        <div style={{ maxWidth: '100%', overflowX: 'auto' }}>
                                                                            <h4 style={{ marginBottom: '15px', color: '#333' }}>Criteria Breakdown</h4>
                                                                            {Object.keys(item.rubric).filter(category => category !== 'totals').map((category, catIdx) => {
                                                                                const categoryData = item.rubric[category];
                                                                                const criteria = categoryData?.criteria || [];

                                                                                return (
                                                                                    <div key={catIdx} style={{ marginBottom: '20px' }}>
                                                                                        <h5 style={{
                                                                                            backgroundColor: '#4a90e2',
                                                                                            color: '#d9d7d7',
                                                                                            padding: '10px',
                                                                                            borderRadius: '4px',
                                                                                            marginBottom: '10px'
                                                                                        }}>
                                                                                            {category} ({categoryData.awarded}/{categoryData.total_points} points)
                                                                                        </h5>
                                                                                        <table style={{
                                                                                            width: '100%',
                                                                                            borderCollapse: 'collapse',
                                                                                            marginBottom: '15px',
                                                                                            backgroundColor: '#d9d7d7'
                                                                                        }}>
                                                                                            <thead>
                                                                                                <tr style={{ backgroundColor: '#e9ecef' }}>
                                                                                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #dee2e6' }}>Criteria Name</th>
                                                                                                    <th style={{ padding: '10px', textAlign: 'center', border: '1px solid #dee2e6', width: '100px' }}>Weight</th>
                                                                                                    <th style={{ padding: '10px', textAlign: 'center', border: '1px solid #dee2e6', width: '100px' }}>Awarded</th>
                                                                                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #dee2e6' }}>Rationale</th>
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>
                                                                                                {criteria.map((criterion, criIdx) => (
                                                                                                    <tr key={criIdx}>
                                                                                                        <td style={{ padding: '10px', border: '1px solid #dee2e6' }}>{criterion.name}</td>
                                                                                                        <td style={{ padding: '10px', textAlign: 'center', color: 'black', border: '1px solid #dee2e6' }}>{criterion.weight}</td>
                                                                                                        <td style={{
                                                                                                            padding: '10px',
                                                                                                            textAlign: 'center',
                                                                                                            border: '1px solid #dee2e6',
                                                                                                            fontWeight: 'bold',
                                                                                                            color: criterion.awarded === criterion.weight ? '#28a745' :
                                                                                                                criterion.awarded > 0 ? '#ffc107' : '#dc3545'
                                                                                                        }}>
                                                                                                            {criterion.awarded}
                                                                                                        </td>
                                                                                                        <td style={{ padding: '10px', color: 'black', border: '1px solid #dee2e6' }}>{criterion.rationale}</td>
                                                                                                    </tr>
                                                                                                ))}
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                );
                                                                            })}


                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ) : null;

                                                            return expandedRow ? [mainRow, expandedRow] : [mainRow];
                                                        });
                                                    })()
                                                ) : (
                                                    <tr>
                                                        <td colSpan="12" style={{ textAlign: 'center' }}>No data found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Pagination Controls */}
                                    {getData && getData.length > 0 && (
                                        <div className="pagination-container">
                                            <div className="pagination-info">
                                                Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, getData.length)} of {getData.length} entries
                                            </div>
                                            <div className="pagination-controls">
                                                <button
                                                    className="pagination-button"
                                                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                                    disabled={currentPage === 1}
                                                >
                                                    Previous
                                                </button>

                                                {(() => {
                                                    const totalPages = Math.ceil(getData.length / itemsPerPage);
                                                    const pageNumbers = [];
                                                    const maxPagesToShow = 5;

                                                    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
                                                    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

                                                    if (endPage - startPage < maxPagesToShow - 1) {
                                                        startPage = Math.max(1, endPage - maxPagesToShow + 1);
                                                    }

                                                    if (startPage > 1) {
                                                        pageNumbers.push(
                                                            <button
                                                                key={1}
                                                                className={`pagination-button ${currentPage === 1 ? 'active' : ''}`}
                                                                onClick={() => setCurrentPage(1)}
                                                            >
                                                                1
                                                            </button>
                                                        );
                                                        if (startPage > 2) {
                                                            pageNumbers.push(<span key="dots1" className="pagination-dots">...</span>);
                                                        }
                                                    }

                                                    for (let i = startPage; i <= endPage; i++) {
                                                        pageNumbers.push(
                                                            <button
                                                                key={i}
                                                                className={`pagination-button ${currentPage === i ? 'active' : ''}`}
                                                                onClick={() => setCurrentPage(i)}
                                                            >
                                                                {i}
                                                            </button>
                                                        );
                                                    }

                                                    if (endPage < totalPages) {
                                                        if (endPage < totalPages - 1) {
                                                            pageNumbers.push(<span key="dots2" className="pagination-dots">...</span>);
                                                        }
                                                        pageNumbers.push(
                                                            <button
                                                                key={totalPages}
                                                                className={`pagination-button ${currentPage === totalPages ? 'active' : ''}`}
                                                                onClick={() => setCurrentPage(totalPages)}
                                                            >
                                                                {totalPages}
                                                            </button>
                                                        );
                                                    }

                                                    return pageNumbers;
                                                })()}

                                                <button
                                                    className="pagination-button"
                                                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(getData.length / itemsPerPage)))}
                                                    disabled={currentPage === Math.ceil(getData.length / itemsPerPage)}
                                                >
                                                    Next
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                }



                {(!isOcrClicked && !isInstallationDataClicked) &&
                    <div>
                        <div className="tab-content tab-main" style={{ marginTop: '110px' }} >
                            <div className="tab-pane fade show active" id="all">
                                <div className="container-fluid mb-3 mt-1 p-2 Searchbar-bg">
                                    <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
                                        <span>
                                            <input type="text" className='search-box p-1 border-0' placeholder="Search" style={{ width: '250px' }} value={getSearchInput || ""}
                                                onChange={(e) => searchUserData(e)}
                                            />
                                            <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
                                        </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        {/* <button className='btn-sm border-0 bg-light'
                                    onClick={getSearchedData}
                                >Search</button> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {loading ? (
                            <div className="loader-wrapper">
                                <div className="loader">
                                    <img src={loader} alt="loading...."></img>
                                </div>
                            </div>
                        ) : (
                            <div className="container-fluid ">

                                <div className="Installation-toggle mt-2">
                                    <span className="toggle-text">Add or Update User</span>
                                    <span className=" float-end">
                                        <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                                    </span>
                                </div>

                                <div className="container shadow mb-3 bg-body rounded mt-4" id="AddNewUser" >
                                    {/* *********Contact Information form******** */}
                                    <div className="container mt-4 p-1">
                                        <form
                                            className="d-flex flex-wrap align-items-center gap-2 small-form px-3 pb-3 rounded"
                                            onSubmit={handleSubmit}
                                        >
                                            {/* Full Name */}
                                            <div className="form-group me-2">
                                                <label className="form-check-label ms-1 small"> Full Name <span className="text-danger fw-bold">*</span> </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    name="full_name"
                                                    placeholder="Full Name"
                                                    value={formData.full_name || ""}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>

                                            {/* Email */}
                                            <div className="form-group me-2">
                                                <label className="form-check-label ms-1 small"> E-mail <span className="text-danger fw-bold">*</span> </label>
                                                <input
                                                    type="email"
                                                    className="form-control form-control-sm"
                                                    name="email"
                                                    placeholder="E-mail"
                                                    value={formData.email || ""}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>

                                            {/* Username */}
                                            <div className="form-group me-2">
                                                <label className="form-check-label ms-1 small"> FFA Username </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    name="username"
                                                    placeholder="Username"
                                                    value={formData.username || ""}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            {/* Checkboxes */}
                                            {["PG", "ProFi", "MRA", "Hotel"].map((field) => (
                                                <div className="form-check form-check-inline d-flex align-items-center me-5" style={{ paddingTop: '2.9rem' }} key={field}>
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={field.toLowerCase()}
                                                        name={field.toLowerCase()}
                                                        checked={formData[field.toLowerCase()] === "1"}
                                                        onChange={handleChange}
                                                    />
                                                    <label className="form-check-label ms-1 small" htmlFor={field} style={{ margin: '0.7rem 0 0.5rem' }}>
                                                        {field == 'ProFi' ? 'Office' : field}
                                                    </label>
                                                </div>
                                            ))}

                                            {/* Status Toggle */}
                                            <div className="form-check form-switch d-flex align-items-center me-5 pt-5">
                                                <input
                                                    className="form-check-input rounded-switch"
                                                    type="checkbox"
                                                    name="status"
                                                    id="status"
                                                    checked={formData.status !== "0"}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            {/* Submit */}
                                            <div className="pt-5">
                                                <button type="submit" className="btn btn-sm btn-success">
                                                    Submit
                                                </button>
                                            </div>

                                            {/* Refresh Icon Button */}
                                            <span className="pt-5" style={{ cursor: 'pointer' }} onClick={refreshClick}>
                                                <img src={refreshIcon} alt="icon" width="20" className='dashboard-icon'></img>
                                            </span>
                                        </form>
                                    </div>
                                </div>

                                <div className="Installation-toggle mt-2">
                                    <span className="toggle-text">Access Control Table</span>
                                    <span className=" float-end">
                                        <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                                    </span>
                                </div>

                                <div className="container shadow mb-3 bg-body rounded mt-4" id="ControllerList" >
                                    {/* *********Contact Information form******** */}
                                    <div className="container mt-3">
                                        {/* Dropdown */}
                                        <div
                                            // className="d-flex justify-content-end mb-2 mt-3 m-5"
                                            className="d-flex justify-content-end align-items-center px-5 py-2 bg-white mb-3"
                                            style={{
                                                position: "sticky",
                                                top: 0,
                                                zIndex: 102,
                                            }}
                                        >
                                            <select className="form-select form-select-sm w-auto" onChange={sortByChange}>
                                                <option value="">Sort By</option>
                                                <option value="NameAZ">Name (A-Z)</option>
                                                <option value="NameZA">Name (Z-A)</option>
                                                <option value="pg">PG</option>
                                                <option value="hotel">Hotel</option>
                                                <option value="office">Office</option>
                                                <option value="mra">MRA</option>
                                                <option value="UpdatedLast">Updated Last</option>
                                                <option value="UpdatedFirst">Updated First</option>
                                                <option value="CreatedLast">Created Last</option>
                                                <option value="CreatedFirst">Created First</option>
                                            </select>

                                            {/* Export Excel Icon Button */}
                                            <span className="" style={{ cursor: 'pointer' }} onClick={() => exportToExcel(userData)}>
                                                <img src={exportExcel} alt="icon" className='dashboard-icon'></img>
                                            </span>

                                            {/* <Select
                                        options={sortOptions}
                                        onChange={sortByChange}
                                        className="w-auto"
                                        classNamePrefix="react-select"
                                        isSearchable={false}
                                        defaultValue={sortOptions[0]} // "Sort By"
                                    /> */}
                                        </div>

                                        <div className="table-responsive custom-scroll-table">
                                            <table className="table table-sm table-bordered align-middle text-center small compact-table hover-highlight">
                                                <thead className="table-dark sticky-header">
                                                    <tr>
                                                        <th className="text-nowrap">#</th>
                                                        <th className="text-nowrap">Full Name</th>
                                                        {/* <th className="text-nowrap">Username</th> */}
                                                        <th className="text-nowrap">Email</th>
                                                        <th className="text-nowrap">PG</th>
                                                        <th className="text-nowrap">Office</th>
                                                        <th className="text-nowrap">MRA</th>
                                                        <th className="text-nowrap">Hotel</th>
                                                        <th className="text-nowrap">Status</th>
                                                        <th className="text-nowrap">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Array.isArray(userData) && userData.length > 0 ?
                                                        userData.map((user, idx) => (
                                                            <tr key={idx}>
                                                                <td className="text-nowrap">{idx + 1}</td>
                                                                <td className="text-nowrap">{user.full_name}</td>
                                                                {/* <td className="text-nowrap">{user.username}</td> */}
                                                                <td className="text-nowrap">{user.email}</td>
                                                                {["pg", "profi", "mra", "hotel"].map((field) => (
                                                                    <td key={field}>
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input m-0"
                                                                            checked={user[field] === "1"}
                                                                            readOnly
                                                                            style={{ opacity: 1, pointerEvents: 'none' }}
                                                                        />
                                                                    </td>
                                                                ))}
                                                                <td>
                                                                    <div className="form-check form-switch d-flex justify-content-center align-items-center">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input rounded-switch"
                                                                            role="switch"
                                                                            id={`statusSwitch${idx}`}
                                                                            checked={user.status === "1"}
                                                                            readOnly
                                                                            style={{ opacity: 1, pointerEvents: 'none' }}
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <i onClick={() => selectedUser(user)} className="fa-solid fa-pen-to-square fa-lg" style={{ cursor: "pointer" }} />
                                                                </td>
                                                            </tr>
                                                        )) : <tr><td colSpan="9" className="text-center text-nowrap fw-bold">No Data Found</td></tr>}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                }
            </>
        );
    } else {
        return (
            <div className="d-flex flex-column justify-content-center align-items-center text-center" style={{ height: '100vh' }}>
                <p className="fs-4 text-warning mb-2">Access Denied!</p>
                <p className="fs-6 text-muted">You do not have the necessary permissions to view this page.</p>
            </div>
        )
    }

};

export default AdminAccess;
